// Indeling van de bibliotheek komt volledig van de server (Europe/Amsterdam); de client
// toont alleen. Zo kan een afwijkende klok of tijdzone van het toestel de indeling niet
// verschuiven.
export const LIBRARY_SECTIONS = [
  { key: 'upcoming', title: 'Komende lessen' },
  { key: 'past', title: 'Eerdere lessen' },
  { key: 'undated', title: 'Zonder datum' },
];

export const formatLessonDate = (value) => (value
  ? new Intl.DateTimeFormat('nl-NL', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })
    .format(new Date(`${String(value).slice(0, 10)}T12:00:00`))
  : null);

export const lessonSubtitle = (lesson) => [
  lesson.series,
  lesson.week_number ? `Week ${lesson.week_number}` : null,
  formatLessonDate(lesson.lesson_date),
].filter(Boolean).join(' · ');

export const libraryIsEmpty = (library) => !library
  || (!library.current && !library.upcoming?.length && !library.past?.length && !library.undated?.length);

export const errorMessage = (error, fallback) => (
  error?.response?.status === 403
    ? 'Je hebt geen toegang tot de lessenbibliotheek.'
    : error?.response?.data?.detail || fallback
);
